import { verifyOTP } from './states';

export const services = {
  verifyOTP,
};
